import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { TransportOrderIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { ShipmentTransportOrderStatusChainState } from './shipment-transport-order-status-chain.state';
import {
  ShipmentTransportOrderStatusChainLoad,
  ShipmentTransportOrderStatusChainSetInitialState,
} from './shipment-transport-order-status-chain.actions';
import { ShipmentTransportOrderStatusChainModel } from '../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderStatusChainFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderStatusChainState.getLoaded);
  statusChain$: Observable<ShipmentTransportOrderStatusChainModel[]> = this.store.select(
    ShipmentTransportOrderStatusChainState.getStatusChainView,
  );

  constructor(private store: Store) {}

  loadAll(identifier: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderStatusChainLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderStatusChainSetInitialState());
  }
}
